import { connect } from 'react-redux';
import BusBookingDateField from '../components/BusBookingSearchForm/BusBookingDateField';
import { setDepartureDate } from '../actions/BusBookingSearchFormAction';

const mapStateToProps = state => {
  const controlSettingData =
    state.bus &&
    state.bus.controlSettings &&
    state.bus.controlSettings.controlSettingsData;

  return {
    departureDate: state.bus.bookingSearchForm.departureDate,
    minimumDateRangeInterval:
      (controlSettingData &&
        controlSettingData.beforeDateCalendar &&
        Number(controlSettingData.beforeDateCalendar.value)) ||
      1,
    maximumDateRangeInterval:
      (controlSettingData &&
        controlSettingData.afterDateCalendar &&
        Number(controlSettingData.afterDateCalendar.value)) ||
      30,
  };
};

const mapDispatchToProps = dispatch => ({
  setDepartureDate: newDate => dispatch(setDepartureDate(newDate)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusBookingDateField);
